import { Component } from '@angular/core';

import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { StylesService } from '../../../../Common/Styles/services/styles.service';
import { MonitorConfigService } from '../../../../Common/MonitorShared/services/monitor-config.service';

import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { CurrencyConversionService } from '../../../../Core/Users/services/currency-conversion.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';

import { MentionMetadataTypesEnum } from '../../../Shared/enums/mention-metadata-types.enum';
import { MentionCustomizationFieldComponent } from '../../../Shared/components/MentionCustomizationField/mention-customization-field.component';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { UserPreferencesService } from '@Account/UserPreferences/services/user-preferences.service';

@Component({
    selector: 'agpr-alert-mention-customization-field',
    templateUrl: '../../../Shared/components/MentionCustomizationField/mention-customization-field.component.html',
    styleUrls: ['../../../Shared/components/MentionCustomizationField/mention-customization-field.component.scss'],
    standalone: false
})
export class AlertMentionCustomizationFieldComponent extends MentionCustomizationFieldComponent {

    constructor(
        protected coreDialogService: CoreDialogService,
        protected stylesService: StylesService,
        protected monitorConfigService: MonitorConfigService,
        public briefingsService: AbstractPageBuilderService,
        protected currentUserStateService: CurrentUserStateService,
        protected currencyConversionService: CurrencyConversionService,
        protected localizationService: LocalizationService,
        protected configService: ConfigService,
        protected userPreferencesService: UserPreferencesService,
    ) {
        super(
            coreDialogService,
            stylesService,
            monitorConfigService,
            briefingsService,
            currentUserStateService,
            currencyConversionService,
            localizationService,
            configService,
            userPreferencesService
        );

        // we want to hide the insights for alert mentions
        this.hideInsights = true;

        this.allowEngagementMetadata = false;

        // we want to hide the insights for alert mentions
        this.hideMentionInsightsLink = true;

        // we wamt to hide wordCount for alert mentions
        this.checkboxOptions = this.checkboxOptions.filter(option => option.key !== MentionMetadataTypesEnum.wordCount);
    }
}
